import { DocSearch } from "../../templates/code-doc/DocSearch";
import { GodotDocsFile } from "./GodotDocsFile";
import { GodotDocsFileIndex } from "./GodotDocsIndex";
import { GodotDocsFileIndex_4_5 } from "./GodotDocsIndex_4_5";
import { GodotDocsFileIndex_4_6 } from "./GodotDocsIndex_4_6";
import { GodotDocsVersion } from "./GodotDocsVersion";


export class GodotDocsIndexType
{
  index:Map<string,GodotDocsFile>;
}

export class GodotDocsIndexSelector
{
  static get currentIndex()
  {
    return GodotDocsIndexSelector.getIndex( GodotDocsVersion.version );
  }


  static getDocInfoFor( className:string, isRokojori:boolean )
  {
    let docIndex = GodotDocsIndexSelector.currentIndex;

    if ( docIndex.index.has( className ) && GodotDocsFile.isRokojori( docIndex.index.get( className ) ) == isRokojori )
    {
      return docIndex.index.get( className );
    }

    return null;
  }

  static getDocInfoForAll( className:string )
  {
    let rokojori = this.getDocInfoFor( className, true );

    if ( rokojori )
    {
      return rokojori;
    }

    return this.getDocInfoFor( className, false );
  }

  static resolvePathFromName( className:string, isRokojori:boolean  )
  {
    let docInfo = this.resolveDocInfoFromName( className, isRokojori );

    return docInfo ? GodotDocsFile.getLink( docInfo ) : "";
  }

  static resolveDocInfoFromName( className:string, isRokojori:boolean  )
  {
    
    let docInfo = this.getDocInfoFor( className, isRokojori );

    if ( docInfo )
    {
      return docInfo;
    }

    let replacers:{ regex:RegExp, replacement:string }[] = 
    [
      {
        regex: /s$/, replacement: ""
      },

      {
        regex: /ies$/, replacement: "y"
      }
    ]

    for ( let r of replacers )
    {
      docInfo = this.getDocInfoFor( className.replace( r.regex, r.replacement ), isRokojori );

      if ( docInfo )
      {
        return docInfo;
      }
    }

    return null;
  }

  static getIndex( version:string ):GodotDocsIndexType
  {
    if ( version == "4.5" )
    {
      return GodotDocsFileIndex_4_5;
    }

    if ( version == "4.6" )
    {
      return GodotDocsFileIndex_4_6;
    }

    return GodotDocsFileIndex;
  }
}